import home from '.';
export default home;
